import { getRecommendation } from "@/api/cg/service/user_service";

class RecommendUtil {
  private recommendList: any;

  public async getRecommendList() {
    try {
      if (!this.recommendList) {
        this.recommendList = await getRecommendation("all_app");
        console.log("getRecommendList", this.recommendList);
      }
      return this.recommendList;
    } catch (e) {
      return [];
    }
  }
}

export default new RecommendUtil();
